<template>
  <div>
    <loader />

    <div class="container content admin-body" v-if="display">
      <div class="right-aligned-box">
        <div style="flex: 0 0 100%">
          <div style="display: flex; flex: 1; justify-content: flex-end; gap: 1rem;">
            <connection-indicator logo="/static/images/fortnox-logo.png" test-action="financeIntegration/testConnection" @click="connectionFortnoxClicked" :key="connectionIndicatorFortnoxKey" />
          </div>
        </div>
      </div>

      <!--<slot :updateMenuActions="updateMenuActions.bind(this, 'buttonText', 'func')" />-->
      <!--<slot :updateMenuActions="() => alert('asdf')" />-->
      <slot />
    </div>

    <bottom-menu>
      <!--
      <template slot-scope="actions">
        <p>{{ actions.text }}</p>
      </template>
      -->
    </bottom-menu>
  </div>
</template>

<script>

import TopNav from '@/components/nav/TopNav'
import BottomMenu from '@/components/nav/BottomMenu'
import Loader from '@/components/actions/Loader'
import ConnectionIndicator from '@/components/other/ConnectionIndicator.vue'

import { mapState, mapActions } from 'vuex'
// import { setFontSizeFromLocalStorage } from '@/helpers'

export default {
  components: {
    TopNav,
    // MainMenu,
    BottomMenu,
    Loader,
    ConnectionIndicator
  },
  data () {
    return {
      isElectron: Boolean,
      connectionIndicatorFortnoxKey: 0,
      display: false
    }
  },

  watch: {
    $route (to, from) {
      this.setHasBackButton()
    }
  },

  computed: {
    ...mapState('auth', ['user', 'status']),
    ...mapState({
      meta: state => state.meta.all
    })
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('userSettings', ['getCurrentUserSettings']),

    connectionFortnoxClicked () {
      this.$infoPopup(null, `<p><img style="height: 4rem; width: auto;" src="/static/images/fortnox-logo.png"></p><p style="margin-top: 2rem;">För att kopplingen med Fortnox ska fungera måste du logga in och ge ditt godkännande. Gör det här:</p><p style="margin-top: 2rem;"><a class="button is-success" href="${this.meta.fortnoxActivationUrl}" target="_blank">Godkänn kopplingen i Fortnox</a></p>`, { icon: null }).then(() => {
        this.connectionIndicatorFortnoxKey++
      })
    },

    setHasBackButton () {
      if (this.$routerHistory.hasPrevious() && this.$routerHistory.previous().path !== '/') {
        document.body.classList.remove('back-button-inactive')
      } else {
        document.body.classList.add('back-button-inactive')
      }
    }
  },

  mounted () {
    this.setHasBackButton()
  },

  created () {
    this.$store.dispatch('meta/getMetaData').then(() => {
      this.display = true
    })
    this.getCurrentUserSettings().then(userSettings => {
      let htmlElement = document.getElementById('html')
      htmlElement.style.fontSize = userSettings.fontSize + 'px'

      // Add class to body if client is electron so we can style some stuff differently, and add a back button
      this.isElectron = window.isElectron()

      if (this.isElectron) {
        document.body.classList.add('is-electron')
      }
    })
    // setFontSizeFromLocalStorage()
  }
}
</script>

<style lang="scss" scoped>
  .right-aligned-box {
    float: right;
    margin-right: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/AdminLayout.vue